var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"ma-0"},[_c('a',{staticClass:"link",attrs:{"href":"tel:+19496408780"}},[_vm._v("+1 (949) 640-8780")])])}]

export { render, staticRenderFns }